import { TextLocalisation } from './en';

export const norwegianLocalisation: TextLocalisation = {
  invalidInput: 'Kortinformasjon er ugyldig eller mangelfull',
  klarnaNotSupported: 'Klarna kan ikke legges til her. Gå tilbake og velg Klarna',
  networkIssue: 'Vipps er ikke tilgjengelig akkurat nå, sjekk nettverk og prøv igjen',
  unknownIssue: 'Uff noe gikk galt',
  cardRefused: 'Kort avvist av bank',
  payButton: 'Neste',
  checkoutTitle: 'Betal',
  checkoutCancel: 'Avbryt',
  checkoutHeader: '{amount} til {merchant}',
  checkoutPay: 'Betal',
  closeButton: 'Lukk',
  poweredBy: 'Levert av',
  tryAgain: 'Prøv igjen',
  unexpectedAuthorisation:
    'Banken støtter ikke autorisasjon av kortet. Vennligst kontakt kundeservice.',
  'creditCard.numberField.title': 'Kortnummer',
  'creditCard.numberField.placeholder': 'Kortnummer',
  'creditCard.numberField.invalid': 'Ugyldig kortnummer',
  'creditCard.expiryDateField.title': 'Utløpsdato',
  'creditCard.expiryDateField.placeholder': 'MM/YY',
  'creditCard.expiryDateField.invalid': 'Ugyldig utløpsdato',
  'creditCard.expiryDateField.month': 'Måned',
  'creditCard.expiryDateField.month.placeholder': 'MM',
  'creditCard.expiryDateField.year.placeholder': 'YY',
  'creditCard.expiryDateField.year': 'År',
  'creditCard.cvcField.title': 'Sikkerhetskode/CVC',
  'creditCard.cvcField.placeholder': '123',
  'creditCard.oneClickVerification.invalidInput.title': 'Ugyldig Sikkerhetskode/CVC',
  'creditCard.cvcField.placeholder.3digits': '3 digits',
  'error.title': 'Noe gikk galt',
  'error.subtitle.redirect': 'Noe gikk galt',
  'error.subtitle.payment': 'Betaling feilet',
  'error.subtitle.refused': 'Betaling feilet',
  'error.message.unknown': 'Noe gikk galt',
  'error.va.gen.01': 'Dette feltet er påkrevd',
  'error.va.gen.02': 'Noe gikk galt her',
  'error.va.sf-cc-num.01': 'Ugyldig kortnummer',
  'error.va.sf-cc-num.02': 'Dette kontonummeret stemmer ikke med korttypen',
  'error.va.sf-cc-num.03': 'Dette kortet er ikke støttet',
  'error.va.sf-cc-dat.01': 'Kortet er for gammelt',
  'error.va.sf-cc-dat.02': 'Datoen er for langt i fremtiden',
  'fscp.error.payment-failed': 'Betalingen feilet',
  'fscp.error.timeout': 'Tiden gikk ut',
  'fscp.error.message.timeout':
    'Det gikk for lang tid uten at det skjedde noe. Du kan starte betalingen på nytt.',
  'fscp.error.unknown': 'Noe gikk galt',
  'fscp.error.message.insufficientFunds':
    'Det er ikke nok penger på kortet. Prøv igjen med et annet kort.',
  'fscp.error.message.invalidCard': 'Kortet ditt ble avvist.',
  'creditCard.encryptedCardNumber.aria.iframeTitle': 'Kortnummer',
  'creditCard.encryptedCardNumber.aria.label': 'Kortnummer',
  'creditCard.encryptedExpiryDate.aria.iframeTitle': 'Utløpsdato',
  'creditCard.encryptedExpiryDate.aria.label': 'Utløpsdato',
  'creditCard.encryptedExpiryMonth.aria.iframeTitle': 'Utløpsmåned',
  'creditCard.encryptedExpiryMonth.aria.label': 'Utløpsmåned',
  'creditCard.encryptedExpiryYear.aria.iframeTitle': 'Utløpsår',
  'creditCard.encryptedExpiryYear.aria.label': 'Utløpsår',
  'creditCard.encryptedSecurityCode.aria.iframeTitle': 'Sikkerhetskode',
  'creditCard.encryptedSecurityCode.aria.label': 'Sikkerhetskode',
  abortFailed: 'Kan ikke kansellere betaling.',
};
